import React from "react";
import {FaFileDownload} from "react-icons/fa"
import userManual from "../../../assets/Manual_usuario_Colombia_v2.2.pdf"

//Estilos base:
const iconStyle = {width: 20, height: 20};


class DownloadManualButton extends React.Component {

    render() {
        return (
            <React.Fragment>
                <li className="nav-item">
                    <a href={userManual} target="_blank" rel="noopener noreferrer">
                        <button className="nav-link btn-magnify button-on-navbar" title="Descargar manual de usuario"
                                style={{backgroundColor: "transparent", border: "none"}}>
                            <FaFileDownload style={iconStyle}/>
                            <p>
                                <span className="d-lg-none d-md-block" style={{marginLeft: 5}}>
                                    Descargar manual de usuario
                                </span>
                            </p>
                        </button>
                    </a>
                </li>
            </React.Fragment>
        );
    }
}

export default DownloadManualButton;